import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { ALL, GET_EMPLOYEES_URL, GET_TASK_URL, PAGE_SIZE } from '../common/constants';
import { formatDate, isEmptyArray } from '../common/util.services';
import './task.scss';
import { getOrderTask } from './task.services';
import SearchPanel from '../../components/search-panel/search-panel.component';
import { Grid } from '@mui/material';
import IDropdown from '../../components/text-component/dropdown/i-dropdown.component';
import { useNavigate } from 'react-router-dom';
import { getMasterDataById } from '../master-data/masterdata.services';
import IDialogComponent from '../../components/dialog/i-dialog.component';
import SpecsComponent from '../master-data/specs/specs.component';

const OrderTaskList = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const navigate = useNavigate();
  const [taskData, setTaskData] = useState(rows);
  const [searchData, setSearchData] = useState<any>({taskOwner: 'LFHADMIN' === appContext.userData.role ? ALL : appContext.userData.name, 
                                                     taskCategory: ALL, 
                                                     task: ALL, 
                                                     status: 'New'});
  const columns: GridColDef[] = [
    { field: 'taskOwner', headerName: 'Owner', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'category', headerName: 'Category', filterable: false, sortable: false, editable: false, width: 100 },
    { field: 'task', headerName: 'Task', filterable: false, sortable: false, editable: false, width: 100 },
    { 
      field: 'details', headerName: 'Details', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className={'NA' !== params.row.details ? "cell-link" : ""}
      onClick={() => { openSpecsPopup(params.row)}}>{params.row.details}</div> }
    },
    { field: 'creationDate', headerName: 'Start Date', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (creationDate: any) => formatDate(creationDate)
    },
    { field: 'targetDate', headerName: 'Target Date', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (targetDate: any) => formatDate(targetDate)
    },
    { field: 'ageing', headerName: 'Ageing', filterable: false, sortable: false, editable: false, width: 65 },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'enquiryCode', headerName: 'Enquiry', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className={'NA' !== params.row.enquiryCode ? "cell-link" : ""}
      onClick={() => { openEnquiryPage(params.row)}}>{params.row.enquiryCode}</div> }
    },
    { field: 'costingCode', headerName: 'Costing', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className={'NA' !== params.row.costingCode ? "cell-link" : ""}
      onClick={() => { openCostingPage(params.row)}}>{params.row.costingCode}</div> }
    },
    { field: 'orderCode', headerName: 'Order', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className={'NA' !== params.row.orderCode ? "cell-link" : ""}
      onClick={() => { openOrderPage(params.row) }}>{params.row.orderCode}</div> }
    },
    { field: 'scheduleCode', headerName: 'Schedule', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className={'NA' !== params.row.scheduleCode ? "cell-link" : ""}
      onClick={() => { openSchedulePage(params.row) }}>{params.row.scheduleCode}</div> }
    },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, editable: false, width: 120 },
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getOrderTask(searchData, page, pageSize, appContext,
        (response: any) => {
          setTaskData(response.data.data);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const openCostingPage = (row: any) => {
    if('NA' !== row.costingCode) {
      navigate('/costing/list/' + row.costingId, {state: {enquiryCode: "", 
                                                          customer: "", 
                                                          product: "", 
                                                          type: "", 
                                                          description: "",
                                                          setQty: row.pack}})
    }
  };

  const openSchedulePage = (row: any) => {
    if('NA' !== row.scheduleCode) {
      navigate('/production/schedule/' + row.scheduleId, {state: {orderId: "", product: ""}})
    }
  };

  const openSpecsPopup = (row: any) => {
    if('NA' !== row.details) {
      getMasterDataById(row.inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const openEnquiryPage = (row: any) => {
    if('NA' !== row.equiryCode) {
      if('Costing' === row.category) {
        navigate('/enquiry/product/list/' + row.enquiryId)
      } else {
        navigate('/enquiry/order/enq/' + row.enquiryCode)
      }
    }
  }

  const openOrderPage = (row: any) => {
    if('NA' !== row.orderCode) {
      if('Add Schedule' === row.task) {
        navigate('/order/product/' + row.orderId)
      } else {
        navigate('/enquiry/order/' + row.orderId, {state: {enquiryCode: row.enquiryCode, customer: "", product: "", description: "", type: ""}})
      }
    }
  };

  const search = (data: any) => {
    setSearchData(data);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1}>
        <Grid xs={3}>
          <IDropdown name='taskOwner' label='Task Owner' url={GET_EMPLOYEES_URL} allItemRequired={true}/>
        </Grid>
        <Grid xs={3}>
          <IDropdown name='taskCategory' label='Task Category' itemList={['Costing', 'Planning', 'Production', 'Quality']} allItemRequired={true} />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='task' label='Task' url={GET_TASK_URL} allItemRequired={true} />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='status' label='Status' itemList={['New', 'In Progress', 'Completed']} allItemRequired={true} />
        </Grid>
      </Grid></SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={taskData} columns={columns} loading={loading} maxHeight={500}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} showAddBtn={false} getRowId={(row: any) => row.id}/>
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
    </>
  }

  return <TitlePanel title='Order Tasks' panelBody={getMainPanel()} />
}

export default OrderTaskList;